<template>
  <el-dialog
    title="选择系统版本"
    :visible.sync="visible"
    width="400px"
    :close-on-click-modal="false"
    @close="handleClose">
    <div class="download-options">
      <div class="download-option" @click="downloadTool('win10')">
        <i class="fab fa-windows"></i>
        <div class="option-info">
          <div class="option-title">Windows 10 及以上</div>
          <div class="option-desc">适用于 Win10/11 系统</div>
        </div>
        <i class="fas fa-download"></i>
      </div>
      <div class="download-option" @click="downloadTool('win8')">
        <i class="fab fa-windows"></i>
        <div class="option-info">
          <div class="option-title">Windows 7/8</div>
          <div class="option-desc">适用于 Win7/8 系统</div>
        </div>
        <i class="fas fa-download"></i>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DownloadDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      configVersion: 0
    }
  },
  computed: {
    downloadUrl() {
      this.configVersion;
      return localStorage.getItem('exeDownLoadUrl') || '';
    },
    downloadUrlWin8() {
      this.configVersion;
      return localStorage.getItem('exeDownLoadUrlWin8') || '';
    }
  },
  watch: {
    show(val) {
      this.visible = val;
    },
    visible(val) {
      this.$emit('update:show', val);
    }
  },
  created() {
    // 监听配置加载完成事件
    window.addEventListener('configLoaded', () => {
      this.configVersion++;
    });
  },
  methods: {
    trackDownloadTool(version) {
      // umami行为统计
      if (typeof umami !== 'undefined') {
        const url = version === 'win8' ? this.downloadUrlWin8 : this.downloadUrl;
        umami.track('downloadExe', {
          version: 'v2.8.0',
          os: version,
          url: url
        });
      }
    },
    downloadTool(version) {
      const url = version === 'win8' ? this.downloadUrlWin8 : this.downloadUrl;
      this.trackDownloadTool(version);
      
      // 如果是Win7/8版本，额外统计win7下载事件
      if (version === 'win8' && typeof umami !== 'undefined') {
        umami.track('downloadWin7', {
          version: 'v2.8.0',
          url: url
        });
      }
      
      window.open(url, '_blank');
      this.visible = false;
    },
    handleClose() {
      this.visible = false;
    }
  }
}
</script>

<style scoped lang="scss">
.download-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.download-option {
  display: flex;
  align-items: center;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    border-color: #2c9b86;
    background-color: #f0f9f7;
  }

  .fab.fa-windows,
  .fas.fa-cube {
    font-size: 24px;
    color: #2c9b86;
    margin-right: 12px;
  }

  .option-info {
    flex: 1;

    .option-title {
      font-size: 14px;
      font-weight: 500;
      color: #333;
      margin-bottom: 4px;
    }

    .option-desc {
      font-size: 12px;
      color: #999;
    }
  }

  .fas.fa-download {
    font-size: 16px;
    color: #2c9b86;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DownloadDialog.vue